import React from 'react'
import { connect } from 'react-redux'
import {
	addListItem, changeListItem, deleteListItem, getListFromValues,
	hasChangedValues, getFormValue, changeItemsValue, nullDate
} from '../../public/utility'

class SalaryDepRatioDiv extends React.Component {
	state = {
		bReadOnly: this.props.bReadOnly || false,
		optionsParas: this.props.optionsParas || null,
	}

	componentDidMount = () => {
	}

	handlerSave = () => {
		const { changedValues基本信息 } = this.state
		const { onSave, onClose } = this.props
		onSave && onSave(changedValues基本信息)
		onClose && onClose()
	}

	handlerDelete = () => {
		const { onDelete, onClose } = this.props
		Tyan.pubForm.showConfirm('确定要删除？', () => {
			onDelete && onDelete()
			onClose && onClose()
		})
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	canSave = () => {
		return this.bChanged() && getFormValue(this, '基本信息', '薪资承担部门') && getFormValue(this, '基本信息', '部门承担比例') && getFormValue(this, '基本信息', '人数统计')
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	fieldset基本信息 = () => {
		const { bReadOnly } = this.state
		return [
			{ _select: '薪资承担部门', minWidth: '95%', required: true, editable: true, forceSelection: true, },
			{ _int: '部门承担比例(%)', name: '部门承担比例', required: true, minWidth: '95%', textAlign: 'left' },
			{ _radio: '人数统计', required: true, items: ['是', '否'], },
		]
	}

	render() {
		const { showMessage: Message, showBody: Body } = this.props
		const { errorMessage, bReadOnly } = this.state

		if (errorMessage) return Tyan.pubForm.showError(errorMessage)

		return <Body data={this} maxWidth="1000"
			controls={
				bReadOnly && [{ _button: '关闭', icon: 'close', handler: this.handlerClose }] ||
				[
					{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.canSave() },
					{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, },
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				]
			}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
				]}
		/>
	}
}

export default connect()(SalaryDepRatioDiv)